import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class SsoAppComponent extends AppComponent {

  constructor(
    app: AppService,
    router: Router,
    @Inject(DOCUMENT) document: Document
  ) {
    super(app, router, document);
    this.context = 'sso';
    this.init();
  }

}
